export default "__VITE_ASSET__Bfq04A2k__"